<template lang="pug">
.wrapper
  top-banner(
    :background="technologyInformation.photo.image",
    :url="technologyInformation.link",
    :title="technologyInformation.photo_title",
    :btnName="technologyInformation.photo_button"
  )
  .pt-5.bg-light
    .container
      h2.text-center {{ technologyInformation.title }}
      p.lead.shrink.d-sm-none(ref="alltext") {{ technologyInformation.subtitle }}
      p.lead.d-none.d-sm-block {{ technologyInformation.subtitle }}
      .row.d-flex.justify-content-center
        .readmore_btn.d-sm-none(@click="expand")
          font-awesome-icon(
            :class="[isLeadExpand ? 'readallmore' : 'readallless']",
            :icon="['fas', 'chevron-up']"
          ) 
      h2.title-features.text-center.mb-0.py-4 Technology Features
      .features(
        v-for="(feature, index) in technologyFeatureList",
        :ref="'feature' + feature.id"
      )
        .pic(
          v-if="feature.photo",
          :style="{ backgroundImage: 'url(' + feature.photo.image + ')' }",
          :class="[index % 2 == 0 ? 'float-left' : 'float-right']"
        )
        .text.float-right.bg-white
          h3 {{ feature.title }}
          p {{ feature.content }}
          a.btn.btn-primary.px-4(@click="relatedClick(feature)") More
    h2.text-center.py-5.mb-0 Related Technology
    .row.related.text-white.bg-dark
      .col-md-6.list(
        v-if="relatedItem",
        v-for="relatedItem in relatedTechnology",
        :style="{ backgroundImage: 'url(' + relatedItem.img + ')' }"
      )
        .box
          h3.text-white {{ relatedItem.title }}
          p {{ relatedItem.description }}
          a.btn.btn-light.px-4(
            style="cursor: pointer",
            @click="relatedClick(relatedItem)"
          ) Details
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
</template>

<script>
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import TopBanner from "@/components/common/TopBanner";
import {
  getTechnologyInformation,
  getTechnologyFeatureList,
} from "@/api/technology";
import Velocity from "velocity-animate";
import { mixins } from "@/mixins/mixins.js";

export default {
  name: "Technology",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  mixins: [mixins],
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
    "top-banner": TopBanner,
  },
  data() {
    return {
      isLeadExpand: false,
      technologyInformation: {
        photo: {
          image: "",
        },
      },
      relatedTechnology: [],
      technologyFeatureList: [],

      metaData: {
        title:
          "Sophisticated Touch Sensing Algorithm｜EETI - Empower TouchSystem ",
      },
    };
  },
  watch: {
    "$route.params.slide_id"() {
      this.$nextTick(() => {
        this.slideToFeature();
      });
    },
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.relatedTechnology = [];
      this.getTechnologyInformation();
      this.getTechnologyFeatureList();
    },
    getTechnologyInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getTechnologyInformation(temp).then((response) => {
        this.technologyInformation = response.data;
        this.relatedTechnology = [];
        let left = {
          title: this.technologyInformation.related_tech_1_title,
          description: this.technologyInformation.related_tech_1_desc,
          img: this.technologyInformation.related_tech_1_photo
            ? this.technologyInformation.related_tech_1_photo.image
            : null,
          link: this.technologyInformation.related_tech_1_link,
        };
        this.relatedTechnology.push(left);
        let right = {
          title: this.technologyInformation.related_tech_2_title,
          description: this.technologyInformation.related_tech_2_desc,
          img: this.technologyInformation.related_tech_2_photo
            ? this.technologyInformation.related_tech_2_photo.image
            : null,
          link: this.technologyInformation.related_tech_2_link,
        };
        this.relatedTechnology.push(right);
      });
    },
    getTechnologyFeatureList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getTechnologyFeatureList(temp).then((response) => {
        this.technologyFeatureList = response.data;

        this.$nextTick(() => {
          this.slideToFeature();
        });
      });
    },
    expand() {
      this.isLeadExpand = !this.isLeadExpand;

      if (this.isLeadExpand) {
        //取得元素完整高度
        var height = this.$refs.alltext.scrollHeight;

        Velocity(this.$refs.alltext, { maxHeight: height }, { duration: 200 });
      } else {
        Velocity(this.$refs.alltext, { maxHeight: 120 }, { duration: 200 });
      }
    },
    slideToFeature() {
      if (!this.$route.params.slide_id) {
        return;
      }
      let ref = "feature" + this.$route.params.slide_id;

      let topLength = 0;

      if (this.$refs[ref][0]) {
        topLength = this.$refs[ref][0].offsetTop - 100;
      }

      window.scrollTo({
        top: topLength,
        behavior: "smooth",
      });
    },
    relatedClick(relatedItem) {
      this.linkClick(relatedItem.link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/technology/technology";
</style>
